'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5>最新公告</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 -</router-link> <a>最新公告</a>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav">
                  <div class="l_nav_item active">
                     <router-link to="/">
                        最新公告 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
               </div>
            </div>
            <div class="list_right">
               <ul class="right_list">
                  <li v-for="(item,index) in list">
                     <router-link :to="'/gonggao/info/'+item.code">
                        <h5 class="l_title">{{item.title}}</h5>
                        <span class="l_date">{{(item.createTime).slice(0,10)}}</span>
                     </router-link>
                  </li>
               </ul>
               <div class="list_pages">
                  <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="pagecount" @current-change="handleCurrentChange">
                  </el-pagination>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'list_page',
      components: {},
      data() {
         return {
            list:[],
            pageNum:1,
            pageSize:10,
            pagecount:10,
         };
      },
      filters: {

      },
      mounted() {
         this.getlist();
      },
      methods: {
         getlist() {
            var _this = this;
            _this.$api.noticeList({
               pageNum:_this.pageNum,
               pageSize:_this.pageSize
            }).then(res => {
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         }
      }
   }
</script>
<style lang="less" scoped>

</style>
